module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/loading-3e7608705d12b2c8e832961e46b1395a.svg";